import deepmerge from 'deepmerge';
import { defaultLoggerConfiguration } from '../../constants';
import { loggerEventEmitter } from '../loggerEventEmitter';
import { canRunLogHandler } from './canRunLogHandler';
import { filterPinoMessage } from './filterPinoMessage';
import { getEnabledLogHandlersForTransport } from './getEnabledLogHandlersForTransport';
export const pinoBrowserRuntimeTransport = options => {
  let {
    loggerConfiguration
  } = options;
  let enabledLogHandlers = getEnabledLogHandlersForTransport(options);

  // When settings in browser change we can just reinitialize transports during runtime
  loggerEventEmitter.addListener('configurationUpdated', updatedLoggerConfiguration => {
    loggerConfiguration = deepmerge(defaultLoggerConfiguration, updatedLoggerConfiguration);
    enabledLogHandlers = getEnabledLogHandlersForTransport({
      ...options,
      loggerConfiguration
    });
  });
  return pinoMessage => {
    // Run all enabled log handlers
    for (const [transportType, logHandler] of enabledLogHandlers) {
      const shouldSkip = !canRunLogHandler({
        loggerConfiguration,
        pinoMessage,
        transportType
      });
      if (shouldSkip) {
        continue;
      }
      logHandler(filterPinoMessage(pinoMessage));
    }
  };
};
//# sourceMappingURL=pinoBrowserRuntimeTransport.js.map